import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from 'Redux/LoggedUserSlice';
import { moduleList } from 'Api/courseDetailsLessons';

const useModules = courseId => {
  const [modules, setModules] = useState();
  const { id } = useSelector(userSelector);

  useEffect(() => {
    moduleList({ courseId, userId: id }).then(data => {
      setModules(data);
    });
  }, [courseId]);

  return {
    modules,
  };
};

export default useModules;
